module.exports = __webpack_public_path__ + "img/server-settings-1.10b9a737.svg";